export type CommunitySocialKey = 'campfire' | 'discord' | 'facebook' | 'instagram';

export const COMMUNITY_SOCIAL_URLS: Record<CommunitySocialKey, string> = {
  campfire: 'https://campfire.onelink.me/eBr8',
  discord: 'https://discord.gg/tR3VMHd',
  facebook: 'https://facebook.com/PokemonGOLaval',
  instagram: 'https://www.instagram.com/pokemongolaval/',
};

export const BOT_INVITE_URL =
  'https://discord.com/oauth2/authorize?client_id=342270229860057089&scope=bot+applications.commands&permissions=126016';

export const BOT_FEATURE_KEYS = ['pokedex', 'trainerCodes', 'ranking', 'shiny', 'profile', 'item'] as const;

export type BotFeatureKey = (typeof BOT_FEATURE_KEYS)[number];
